import React from 'react';
import './LogoShowcase.css';

function LogoShowcase() {
  return (
    <div className="logo-showcase">
      <div className="logo-showcase-glow" />
      <div className="logo-showcase-ring ring-1" />
      <div className="logo-showcase-ring ring-2" />
      <div className="logo-showcase-ring ring-3" />
      <div className="logo-showcase-dots" />
      <div className="logo-showcase-frame">
        <img
          src="/images/Stupa-primarylogo.png"
          alt="STUPA Developmental Foundation"
          className="logo-showcase-img"
        />
      </div>
      <AccentBadge />
    </div>
  );
}

function AccentBadge() {
  return (
    <div className="logo-showcase-badge">
      <span className="logo-badge-year">Est. 2024</span>
      <span className="logo-badge-divider" />
      <span className="logo-badge-text">New Delhi, India</span>
    </div>
  );
}

export default LogoShowcase;
